/*
 * Typing rules for the single date-of-birth box on the video join page (KIN-1953): DD / MM /
 * YYYY in one field, moving on to the next part as soon as the current one can hold nothing
 * more, so the patient types the date as they would write it.
 */

export const DATE_OF_BIRTH_PARTS = ["day", "month", "year"];

const MAX_LENGTH = { day: 2, month: 2, year: 4 };

// The largest first digit that can still start a two-digit day or month. Typing anything
// above it ("5" for a day, "2" for a month) is already a whole part.
const LARGEST_LEADING_DIGIT = { day: 3, month: 1 };

export const maxLengthOf = (part) => MAX_LENGTH[part];

export const keepDigits = ({ part, value }) =>
  String(value ?? "").replace(/\D/g, "").slice(0, MAX_LENGTH[part]);

/** Whether the part can take no more digits, so the cursor should move to the next one. */
export const isPartComplete = ({ part, value }) => {
  if (value.length >= MAX_LENGTH[part]) return true;

  if (part === "year" || value.length !== 1) return false;

  return Number(value) > LARGEST_LEADING_DIGIT[part];
};

/**
 * A whole date pasted or autofilled into one part, as "17/05/1980", "17-5-1980" or "17.05.1980".
 * Null when the text isn't one, so the paste is handled as ordinary typing.
 */
export const splitDateText = (text) => {
  const match = String(text ?? "").trim().match(/^(\d{1,2})\s*[/.\-\s]\s*(\d{1,2})\s*[/.\-\s]\s*(\d{4})$/);

  return match ? { day: match[1], month: match[2], year: match[3] } : null;
};
